<template>
  <!-- 服务流程 -->
  <section id="service" class="service">
    <StatsHeader 
      title="服务流程"
      subtitle="网络综合公司，提供包括云计算、移动互联网软件、web 服务、软硬件一体化开发、系统运维在内的全方位软件解决方案与服务。"
    />
    
    <div class="services">
      <div class="service-item">
        <i class="fas fa-comments"></i>
        <h4 class="service-title">需求沟通</h4>
        <p class="service-content">
          客户提出网站建设基本需求，包括设计风格、功能模块等。
        </p>
      </div>
      <div class="service-item">
        <i class="fas fa-sign-in-alt"></i>
        <h4 class="service-title">项目评估</h4>
        <p class="service-content">
          根据客户提出的需求评估项目开发周期与费用预算。
        </p>
      </div>
      <div class="service-item">
        <i class="fas fa-file-signature"></i>
        <h4 class="service-title">签订合同</h4>
        <p class="service-content">
          双方确认费用、工期及合作细节后，签署正式合作协议。
        </p>
      </div>
      <div class="service-item">
        <i class="fas fa-user"></i>
        <h4 class="service-title">提案阶段</h4>
        <p class="service-content">
          完成网站初稿设计，包括网站首页、内页设计方案。
        </p>
      </div>
      <div class="service-item">
        <i class="fas fa-chalkboard-teacher"></i>
        <h4 class="service-title">制作阶段</h4>
        <p class="service-content">
          完成全页面设计、程序开发及前后端整合，实现网站功能落地。
        </p>
      </div>
      <div class="service-item">
        <i class="fas fa-user-check"></i>
        <h4 class="service-title">网站验收</h4>
        <p class="service-content">
          根据合同条款进行网站验收，签署确认单后项目交付。
        </p>
      </div>
    </div>
  </section>
</template>

<script setup>
import { onMounted } from "vue";
import ScrollReveal from "scrollreveal";
import StatsHeader from "./StatsHeader.vue";

// 动画配置项（从下到上）
const staggeringOption = {
  delay: 300,
  distance: "50px",
  duration: 500,
  easing: "ease-in-out",
  origin: "bottom",
};

onMounted(() => {
  // 服务流程滚动动画
  ScrollReveal().reveal(".service-item", {
    ...staggeringOption,
    interval: 350,
  });
});
</script>

<style scoped>
.service {
  margin-top: 80px;
}

.services {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: 1fr 1fr;
  column-gap: 38px;
  row-gap: 34px;
  width: 100%;
}

.service-item {
  display: grid;
  grid-template-areas:
    "icon title"
    "icon content";
  grid-template-columns: 70px 1fr;
  grid-template-rows: 1fr 3fr;
  padding: 24px;
  box-shadow: 0px 0px 18px rgba(0, 0, 0, 0.06);
  border-radius: 8px;
}

.service-item i.fas {
  grid-area: icon;
  font-size: 42px;
  color: var(--primary-color);
  padding-top: 6px;
}

.service-item .service-title {
  grid-area: title;
  color: var(--text-color-darker);
  font-size: 24px;
}

.service-item .service-content {
  grid-area: content;
  color: var(--text-color-gray);
  line-height: 30px;
  font-size: 16px;
  margin-top: 8px;
}

/* 响应式样式 - 平板设备 */
@media (max-width: 992px) {
  .services {
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(3, 1fr);
    column-gap: 24px;
    row-gap: 24px;
  }
  
  section {
    padding: 0 40px;
  }
}

/* 响应式样式 - 手机设备（核心：单列排列） */
@media (max-width: 768px) {
  .services {
    grid-template-columns: 1fr; /* 单列排列 */
    grid-template-rows: repeat(6, auto); /* 自动适应高度 */
    row-gap: 20px;
  }
  
  .service-item {
    grid-template-columns: 60px 1fr; /* 缩小图标区域 */
    padding: 20px 16px; /* 减小内边距 */
  }
  
  .service-item i.fas {
    font-size: 36px; /* 缩小图标 */
  }
  
  .service-item .service-title {
    font-size: 20px; /* 缩小标题 */
  }
  
  .service-item .service-content {
    font-size: 14px; /* 缩小内容文字 */
    line-height: 24px; /* 调整行高 */
  }
  
  section {
    padding: 0 20px; /* 减小左右内边距 */
  }
  
  .service {
    margin-top: 60px; /* 减小顶部间距 */
  }
}

/* 小屏手机适配 */
@media (max-width: 480px) {
  .service-item {
    grid-template-columns: 50px 1fr;
    padding: 16px 12px;
  }
  
  .service-item i.fas {
    font-size: 32px;
  }
}
</style>